module.exports = __webpack_public_path__ + "static/media/Logo_color_SKHU_HU_RGB.8eece4fa.jpg";